export default "__VITE_ASSET__CLw41i5u__"